import AppRouting from '../routing/AppRouting';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  ThemeOptions,
} from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

const App = () => {
  const secondary = '#fff';
  const primary = '#06828F';

  const themeColors: ThemeOptions = {
    palette: {
      mode: 'light',
      primary: {
        main: primary,
      },
      secondary: {
        main: secondary,
      },
      info: {
        main: '#6c6d6e',
      },
    },
  };

  let theme = createTheme(themeColors);
  theme = createTheme(theme, {
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 400,
            fontSize: 14,
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            fontSize: 16,
            color: theme.palette.primary.light,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            color: theme.palette.primary.light,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            fontSize: 15,
            textTransform: 'unset',
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
          },
        },
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AppRouting />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
